import React from 'react';
import Data from './Data';
import Active from './Active';

class ProfileStep extends React.Component<Props, {}> {
    static Active = Active;
    static Data = Data;

    render() {
        const { children, ...rest } = this.props;
        return <div>{children(rest)}</div>;
    }
}

interface Props {
    user;
    children;
}

export default ProfileStep;
